import React from 'react'

export const FeedbackPage = React.lazy(() => import('./feedback-tabs'))
